import { render, staticRenderFns } from "./BetTypeSelector.vue?vue&type=template&id=aa239100"
import script from "./BetTypeSelector.vue?vue&type=script&lang=js"
export * from "./BetTypeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports